import { Injectable } from '@angular/core';
import { AnnualReportNavigationProvider, AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe';
import { CompaniesProvider, PersonsProvider, TagsProvider } from '@modeso/aumico-lib-companies-fe';
import { AumicoCoreLayoutProvider, AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { NotesProvider } from '@modeso/aumico-lib-notes-fe';
import { TemplatesProvider } from '@modeso/aumico-lib-templates-fe';
import { OrganizationProvider } from '@modeso/aumico-lib-users-fe';
import { Store } from '@ngrx/store';
import { TasksOverviewState } from '../../../../../aumico-lib-cpmm-fe/src/lib';
import { TasksOverviewActions } from '../../../../../aumico-lib-cpmm-fe/src/lib/actions/tasks.actions';
import { PersonProjectsActions, ProjectsOverviewActions, ProjectsOverviewState } from '../../../../../aumico-lib-projects-fe/src/lib';

@Injectable({ providedIn: 'root' })
export class ResetStoreService {
    constructor(
        private readonly companiesProvider: CompaniesProvider,
        private readonly annualReportProvider: AnnualReportProvider,
        private readonly templatesProvider: TemplatesProvider,
        private readonly notesProvider: NotesProvider,
        private readonly annualReportNavigationProvider: AnnualReportNavigationProvider,
        private readonly aumicoCoreLayoutProvider: AumicoCoreLayoutProvider,
        private readonly aumicoCoreProvider: AumicoCoreProvider,
        private readonly organizationProvider: OrganizationProvider,
        private projectsOverviewStore: Store<ProjectsOverviewState>,
        private tasksOverviewStore: Store<TasksOverviewState>,
        private readonly personsProvider: PersonsProvider,
        private readonly tagsProvider: TagsProvider,
    ) {}

    public resetAllStores(): void {
        this.resetAnnualReports();
        this.resetCompanies();
        this.resetTemplates();
        this.resetNotes();
        this.resetAnnualReportNavigation();
        this.resetLayout();
        this.resetOverlay();
        this.resetCurrentOrganization();
        this.resetProjects();
        this.resetTasks();
        this.resetPersons();
    }

    /** REV-22155 — persons, their tags and person projects (SRR F1: nothing of the previous user stays). */
    public resetPersons(): void {
        this.personsProvider.resetPersons();
        this.tagsProvider.resetTags();
        this.projectsOverviewStore.dispatch(PersonProjectsActions.resetPersonProjects());
    }

    public resetCompanies(): void {
        this.companiesProvider.resetCompanies();
    }

    public resetAnnualReports(): void {
        this.annualReportProvider.resetAnnualReports();
    }

    public resetProjects(): void {
        this.projectsOverviewStore.dispatch(ProjectsOverviewActions.resetProjectsOverviewState());
    }

    public resetTasks(): void {
        this.tasksOverviewStore.dispatch(TasksOverviewActions.resetTasksOverviewState());
    }

    public resetTemplates(): void {
        // resetting property of the state that is only used in project-reports saas
        this.templatesProvider.resetTemplateByLegalFormAndAccountBasis();
    }

    public resetNotes(): void {
        this.notesProvider.resetNotes();
    }

    public resetAnnualReportNavigation(): void {
        this.annualReportNavigationProvider.resetActiveArNavigation();
    }

    private resetLayout(): void {
        this.aumicoCoreLayoutProvider.resetLayout();
    }

    private resetOverlay(): void {
        this.aumicoCoreProvider.dispatchResetOverlay();
    }

    private resetCurrentOrganization(): void {
        this.organizationProvider.resetCurrentOrganization();
    }
}
